module.exports = require('./helpers/bundle-url').getBundleURL('41p19') + "../chesapeake-progress-logo--icon-only.3d6cd5b5.svg";